import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mt-4 d-xxl-flex d-lg-none d-xl-none d-xxl-block" }
const _hoisted_2 = { class: "col-12 col-sm-6 col-xl-6 col-xxl-3 mb-2" }
const _hoisted_3 = { class: "col-12 col-sm-6 col-xl-6 col-xxl-3 mb-2" }
const _hoisted_4 = { class: "col-12 col-sm-6 col-xl-6 col-xxl-3 mb-2" }
const _hoisted_5 = { class: "col-12 col-sm-6 col-xl-6 col-xxl-3 mb-2" }
const _hoisted_6 = { class: "row mt-3" }
const _hoisted_7 = {
  key: 0,
  class: "col-12 col-lg-12 col-xxl-8 order-1 order-lg-3 d-flex flex-row mb-4 mb-xl-0"
}
const _hoisted_8 = { class: "w-100 bg-light rounded border" }
const _hoisted_9 = { class: "col-12 col-lg-6 col-xxl-4 order-2 order-lg-1 d-flex flex-row mb-4 mb-xxl-0" }
const _hoisted_10 = { class: "col-lg-6 d-none d-lg-block d-xxl-none order-2" }
const _hoisted_11 = { class: "row mt-4" }
const _hoisted_12 = {
  key: 0,
  class: "col-12 col-lg-6 col-xxl-4 flex-row mb-4 mb-xxl-0"
}
const _hoisted_13 = {
  key: 1,
  class: "col-12 col-lg-6 col-xxl-4 flex-row mb-4 mb-xxl-0"
}
const _hoisted_14 = {
  key: 2,
  class: "col-12 col-xxl-8 order-2 flex-row mb-4 mb-xxl-0"
}
const _hoisted_15 = { class: "col-12 col-xxl-4 mb-4 mb-xl-0" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-12 col-lg-6 col-xxl-12 mb-4 mb-lg-0 mb-xxl-2" }
const _hoisted_18 = { class: "col-12 col-lg-6 col-xxl-12" }
const _hoisted_19 = {
  class: "modal fade",
  id: "resendEmail",
  tabindex: -1,
  role: "dialog"
}
const _hoisted_20 = { class: "vertical-alignment-helper" }
const _hoisted_21 = { class: "modal-dialog vertical-align-center" }
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = { class: "modal-header" }
const _hoisted_24 = { class: "modal-footer" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ticket_header = _resolveComponent("ticket-header")!
  const _component_commissions_summary = _resolveComponent("commissions-summary")!
  const _component_subscriptions_card = _resolveComponent("subscriptions-card")!
  const _component_scholarship_card = _resolveComponent("scholarship-card")!
  const _component_binary_card = _resolveComponent("binary-card")!
  const _component_unilevel_card = _resolveComponent("unilevel-card")!
  const _component_videos_carousel = _resolveComponent("videos-carousel")!
  const _component_leader_board_card = _resolveComponent("leader-board-card")!
  const _component_images_carousel = _resolveComponent("images-carousel")!
  const _component_ranks_card = _resolveComponent("ranks-card")!
  const _component_registration_link_card = _resolveComponent("registration-link-card")!
  const _component_image_modal = _resolveComponent("image-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.config?.eventHeader?.active)
      ? (_openBlock(), _createBlock(_component_ticket_header, {
          key: 0,
          ticketsInfo: _ctx.ticketsInfo,
          home: true,
          event: _ctx.event
        }, null, 8, ["ticketsInfo", "event"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_commissions_summary, { summary: _ctx.summary }, null, 8, ["summary"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_subscriptions_card, { class: "h-100" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_scholarship_card, { class: "h-100" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_binary_card, { class: "h-100" })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_unilevel_card, { class: "h-100" })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.config.videos.active)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_videos_carousel, {
                playlist: _ctx.config.videos.playlist
              }, null, 8, ["playlist"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_leader_board_card)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_subscriptions_card, { class: "mb-2" }),
        _createVNode(_component_scholarship_card, { class: "mb-2" }),
        _createVNode(_component_binary_card, { class: "mb-2" }),
        _createVNode(_component_unilevel_card, { class: "mb-4" })
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.config.notices.left.active)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_images_carousel, {
              class: "border rounded-2",
              imagesArray: _ctx.config.notices.left.images,
              imgClass: 'rounded-2'
            }, null, 8, ["imagesArray"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.config.notices.middle.active)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_images_carousel, {
              class: "border rounded-2",
              imagesArray: _ctx.config.notices.middle.images,
              imgClass: 'rounded-2'
            }, null, 8, ["imagesArray"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.config.notices.wide.active)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_images_carousel, {
              class: "border rounded-2",
              imagesArray: _ctx.config.notices.wide.images,
              imgClass: 'rounded-2'
            }, null, 8, ["imagesArray"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_ranks_card, { "user-ranks-carrer-data": _ctx.ranksCarrerData }, null, 8, ["user-ranks-carrer-data"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_registration_link_card)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "modal-title" }, "Favor de verificar tu cuenta", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-close",
                "data-dismiss": "modal",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                "aria-label": "Close"
              })
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal-body" }, [
              _createElementVNode("span", null, "Para disfrutar todos los beneficios de la plataforma, es necesario que verifiques el correo electrónico ligado a tu cuenta ")
            ], -1)),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resendEmail())),
                disabled: _ctx.loading
              }, [
                _cache[3] || (_cache[3] = _createTextVNode(" Reenviar correo de confirmación ", -1)),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_25)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.config.modal.active)
      ? (_openBlock(), _createBlock(_component_image_modal, {
          key: 1,
          "modal-id": _ctx.imageModalId,
          image: _ctx.config.modal.image,
          "close-button-class": "btn-close-white position-absolute top-0 end-0"
        }, null, 8, ["modal-id", "image"]))
      : _createCommentVNode("", true)
  ], 64))
}